/*
 * @Author: zhangsheng
 * @Date: 2023-08-22 14:53:39
 * @LastEditors: zhangsheng
 * @LastEditTime: 2023-10-07 14:13:54
 * @FilePath: \panda-index-sicermem-frontend\src\pc\router\pageRouter.tsx
 * @Description:
 *
 * Copyright (c) 2023 by zhangsheng , All Rights Reserved.
 */
// import { MenuRoute } from '@c/types/router';
import { Children, lazy } from 'react';
import lazyLoad from '@c/components/lozyLoad';
import React from 'react';
import { Navigate } from 'react-router';
import i18next from '@/i18n';
const Index = lazyLoad(lazy(() => import(`@p/pages/Index`)));
const Product = lazyLoad(lazy(() => import(`@p/pages/Product`)));
const ProductDetail = lazyLoad(lazy(() => import(`@p/pages/ProductDetail`)));
const AboutLayout = lazyLoad(lazy(() => import(`@p/pages/AboutUs/Layout`)));
const AboutUs = lazyLoad(lazy(() => import(`@p/pages/AboutUs`)));
const Componey = lazyLoad(lazy(() => import(`@p/pages/AboutUs/Componey`)));
const TestCenter = lazyLoad(lazy(() => import(`@p/pages/AboutUs/TestCenter`)));
const Purpose = lazyLoad(lazy(() => import(`@p/pages/AboutUs/Purpose`)));
const Qualifications = lazyLoad(lazy(() => import(`@p/pages/AboutUs/Qualifications`)));
const Contact = lazyLoad(lazy(() => import(`@p/pages/ContactUs`)));
const NoMatch = lazyLoad(lazy(() => import(`@p/components/404`)));
const DomesticWater = lazyLoad(lazy(() => import(`@p/pages/ApplicationArea/DomesticWater`)));
const WastewaterTreatment = lazyLoad(lazy(() => import(`@p/pages/ApplicationArea/WastewaterTreatment`)));
const SeaWaterDesalination = lazyLoad(lazy(() => import(`@p/pages/ApplicationArea/SeaWaterDesalination`)));
const LivestockAndPoultryBreeding = lazyLoad(
  lazy(() => import(`@p/pages/ApplicationArea/LivestockAndPoultryBreeding`)),
);
const IndustrialSewage = lazyLoad(lazy(() => import(`@p/pages/ApplicationArea/IndustrialSewage`)));
const IndustrialSeparation = lazyLoad(lazy(() => import(`@p/pages/ApplicationArea/IndustrialSeparation`)));
const SearchConsult = lazyLoad(lazy(() => import(`@p/pages/SearchConsult`)));
const CoreTechnology = lazyLoad(lazy(() => import(`@p/pages/CoreTechnology`)));
const PetIntroduction = lazyLoad(lazy(() => import(`@p/pages/PetIntroduction`)));
const InfoQuery = lazyLoad(lazy(() => import(`@p/pages/InfoQuery`)));
const PetShop = lazyLoad(lazy(() => import(`@p/pages/PetShop`)));

const pageRouter: any = [
  {
    path: '',
    name: '首页',
    key: '/home',
    // index: true,
    hideMenu: true,
    exact: true,
    element: Index,
  },
  {
    path: 'aboutus',
    name: '关于我们',
    key: i18next.t('AboutUs.index.745708-10'),
    element: AboutLayout,
    children: [
      {
        index: true,
        element: <Navigate to="introduce" replace />,
        hideMenu: true,
      },
      {
        path: 'introduce',
        name: '犬舍介绍',
        key: '/aboutus/introduce',
        element: AboutUs,
      },
      {
        path: 'componey',
        name: '犬舍实力',
        key: '/aboutus/componey',
        element: Componey,
      },
      // {
      //   path: 'testCenter',
      //   name: i18next.t('Layout.index.749881-2'),
      //   key: i18next.t('AboutUs.index.745708-13'),
      //   element: TestCenter,
      // },
      // {
      //   path: 'purpose',
      //   name: i18next.t('Layout.index.749881-3'),
      //   key: i18next.t('AboutUs.index.745708-14'),
      //   element: Purpose,
      // },
      // {
      //   path: 'qualifications',
      //   name: '犬舍资质',
      //   key: '/aboutus/qualifications',
      //   element: Qualifications,
      // },
    ],
  },
  {
    path: 'petIntroduction',
    name: '宠物介绍',
    key: '/petIntroduction',
    element: PetIntroduction,
    children: []
  },
  {
    path: 'infoQuery',
    name: '信息查询',
    key: '/infoQuery',
    element: InfoQuery,
    children: []
  },
  {
    path: 'petShop',
    name: '宠物商店',
    key: 'petShop',
    element: PetShop,
    children: []
  },
  {
    path: 'contact',
    name: i18next.t('ContactUs.index.792848-0'),
    key: i18next.t('ContactUs.index.792848-3'),
    element: Contact,
    children: [
    ],
  },
  {
    path: 'searchConsult',
    name: '搜索结果',
    key: i18next.t('Index.index.076615-49'),
    element: SearchConsult,
    hideMenu: true,
  },
  {
    path: '404',
    name: '404',
    key: '/404',
    exact: true,
    hideMenu: true,
    element: NoMatch,
  },
  {
    path: '*',
    name: '404',
    key: '/404',
    hideMenu: true,
    element: <Navigate to="/404" replace />,
  },
];

export default pageRouter;
